import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HelpPageComponent } from './help-page/help-page.component';

const routes: Routes = [
  {
    path: "help",
    component: HelpPageComponent,
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class HelpRoutingModule { }



// WEBPACK FOOTER //
// F:/PHAZP5152IS01-2/_work/98/s/src/app/help/help-routing.module.ts